<div class="container-fluid py-4">
  <div class="card">
    <div class="card-header">
      <div class="card-tools">
        <a
          [routerLink]="['/administracion/roles/add']"
          class="btn btn-dark btn-sm btn-new"
        >
          New
        </a>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data">
              <td>{{ item.name }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Activo" : "Inactivo" }}
                </span>
              </td>
              <td>
                <!-- Opción A: path absoluto -->
                <a
                  [routerLink]="['/administracion/roles/edit', item._id]"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-edit"></i>
                </a>

                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
